import {createContext} from 'react';
import {User} from '../user/user.interface';

export const UserContext = createContext<User | undefined>(undefined);
